var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapprLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 112.5 112.499997",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d30cd1502b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.292969 2 L 96 2 L 96 83 L 20.292969 83 Z M 20.292969 2 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "96df158899"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.292969 55 L 96 55 L 96 100.878906 L 20.292969 100.878906 Z M 20.292969 55 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d30cd1502b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 78.480469 26.199219 L 78.480469 23.761719 C 78.480469 12.960938 70.320312 3.511719 59.476562 2.777344 C 47.605469 1.996094 37.6875 11.375 37.6875 23.027344 L 37.6875 26.175781 L 26.390625 26.175781 C 23.152344 26.175781 20.539062 28.78125 20.539062 32.003906 L 20.539062 82.308594 L 72.222656 82.308594 C 74.816406 82.308594 77.195312 80.460938 77.457031 77.878906 C 77.765625 74.917969 75.433594 72.410156 72.507812 72.410156 L 59.6875 72.410156 C 53.363281 72.410156 47.726562 67.8125 47.105469 61.5625 C 46.394531 54.386719 52.078125 48.296875 59.140625 48.296875 L 95.605469 48.296875 L 95.605469 31.980469 C 95.605469 28.757812 92.988281 26.152344 89.753906 26.152344 L 78.480469 26.152344 Z M 44.824219 26.199219 L 44.824219 23.050781 C 44.824219 15.78125 50.769531 9.859375 58.070312 9.859375 C 65.375 9.859375 71.320312 15.78125 71.320312 23.050781 L 71.320312 26.199219 Z M 44.824219 26.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96df158899)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 54.21875 60.921875 C 54.480469 63.503906 56.859375 65.351562 59.453125 65.351562 L 71.960938 65.351562 C 78.289062 65.351562 83.925781 69.945312 84.546875 76.199219 C 85.257812 83.375 79.574219 89.460938 72.507812 89.460938 L 20.539062 89.460938 L 20.539062 95.265625 C 20.539062 98.484375 23.152344 101.089844 26.390625 101.089844 L 89.777344 101.089844 C 93.011719 101.089844 95.628906 98.484375 95.628906 95.265625 L 95.628906 55.476562 L 59.164062 55.476562 C 56.265625 55.449219 53.933594 57.960938 54.21875 60.921875 Z M 54.21875 60.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapprLogoSmall);
export default __webpack_public_path__ + "static/media/swapprLogoSmall.18869edf63a6ad1e9b05fed349060b31.svg";
export { ForwardRef as ReactComponent };